import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './forms/Input.scss';
import './ChangePassword.scss';

import Dialog from './dialogs/Dialog';
// import withStorage from './utils/withStorage';
import Input from './forms/Input';
import withMeta from './utils/withMeta';

/**
 * Change password component
 * @module
 * @param {bool} isOpenChangePassword - Is dialog open? 
 * @param {func} handleConfirmChangePassword - Function on password change submit
 * @param {func} handleClose - Closes dialog function
 * @param {(string | number)} value - Value
 * 
 */
const ChangePassword = (props) => {
  const [formData, setFormData] = useState({
    newPassword: '',
    matchNewPassword: '',
    error: null,
    text: "",
  });

  useEffect(() => {
    const getText = async () => {
      const text = await props.meta.getDef(3001001, 3001001007);
      setFormData(prevData => ({ ...prevData, text }));
    };

    getText();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (field, value) => {
    setFormData(prevData => ({ ...prevData, [field]: value }));
  };

  const handleClose = () => {
    props.handleClose();
    setFormData(prevData => ({
      ...prevData,
      newPassword: '',
      matchNewPassword: '',
      error: '',
    }));
  };

  const handleConfirm = () => {
    if (formData.newPassword !== formData.matchNewPassword) {
      setFormData(prevData => ({
        ...prevData,
        error: 'Potvrdenie hesla sa nezhoduje s novým heslom',
      }));
      return;
    }

    props.handleConfirmChangePassword(formData.newPassword);
    handleClose();
  };

  return (
    <Dialog
      isOpen={props.isOpenChangePassword}
      onClose={handleClose}
      onConfirm={handleConfirm}
      title="Zmena hesla"
      width={600}
      confirmDisabled={formData.newPassword.length === 0 || formData.matchNewPassword.length === 0}
    >
      <div className="k-content k-window-content k-dialog-content settings change-password">
        <div className="k-form-inline">
          <div className="text-password">
            {formData.text && <span>{formData.text}</span>}
          </div>
          <div className="error-password">
            {formData.error && <span>{formData.error}</span>}
          </div>
          <div className="k-form-field">
            <span className="title">Nové heslo</span>
            <Input
              type="password"
              name="newPassword"
              onChange={handleChange}
              value={formData.newPassword}
            />
          </div>
          <div className="k-form-field">
            <span className="title">Potvrdenie nového hesla</span>
            <Input
              type="password"
              name="matchNewPassword"
              onChange={handleChange}
              value={formData.matchNewPassword}
            />
          </div>
        </div>
      </div>
    </Dialog>
  );

}

ChangePassword.propTypes = {
  isOpenChangePassword: PropTypes.bool.isRequired,
  handleConfirmChangePassword: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
}

export default withMeta(ChangePassword);